export default __webpack_public_path__ + "static/3d-fabric-light-box-buyer-view-26a21c474877366d3376e85f20f4c64d.png";